import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import randomstring from 'uuid/v4';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/user.actions';
import * as actionsHome from '../../../../actions/process.home.actions';

import Grid from '@material-ui/core/Grid';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import BlueButton from '../../../buttons/BlueButton';
import User from './User';

const pagination = 15;

function getSurnameFormat(name) {
    return name ? name.replace(',', '').trim() : '';
}

function sortData(arr, search, all_employees) {
    if (!arr) {
        return arr;
    } else {
        const result = []
            .concat(arr)
            .sort((a, b) =>
                a.nombre.toUpperCase().trim() + ' ' + getSurnameFormat(a.apellidos).toUpperCase() <
                    b.nombre.toUpperCase().trim() + ' ' + getSurnameFormat(b.apellidos).toUpperCase()
                    ? -1
                    : 1,
            )
            .reduce((arr, info) => {
                if (search && search.length > 0) {
                    const filter = search.filter(
                        (s) =>
                            (info.nombre && info.nombre.toUpperCase().includes(s)) ||
                            (info.apellidos && info.apellidos.toUpperCase().includes(s)) ||
                            (info.login && info.login.toUpperCase().includes(s)),
                    );
                    if (filter && filter.length > 0 && (all_employees || info.activo)) {
                        arr.push(<User key={randomstring()} user={info} />);
                    }
                } else if (all_employees || info.activo) {
                    arr.push(<User key={randomstring()} user={info} />);
                }
                return arr;
            }, []);
        return result;
    }
}

class ListEmployees extends React.Component {
    state = {
        index: 0,
        users: sortData(this.props.users, this.props.search, this.props.all_employees),
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            index: 0,
            users: sortData(nextProps.users, nextProps.search, nextProps.all_employees),
        });
    }

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleClick = (event) => {
        this.setState({ index: this.state.index + pagination });
    };

    render() {
        const { index, users } = this.state;
        const { users_is_loading, users_has_errored, licencia } = this.props;
        const data = [...users].splice(0, index + pagination);
        const length = users.length;

        if (users_has_errored.hasErrored) {
            return <Error open type={users_has_errored.hasErrored} message={users_has_errored.error} handleClose={this.handleBack} />;
        } else if (!users_is_loading && users === undefined) {
            return (
                <Error
                    open
                    message={<FormattedMessage id="error_users_not_found" />}
                    handleClose={this.handleBack}
                />
            );
        } else {
            return (
                <div className={'flex_full_column padding_bottom_9 width100 height100'}>
                    {users_is_loading && <Loading open opacity />}
                    <div className="flex_full overflow_y_scroll" onScroll={this.handleScroll}>
                        {
                            <div className={"flex_auto_row c_white padding_borders center " + ( (licencia.quota === -1 || licencia.quotaUsed / licencia.quota < 0.50)  ? "bg_pealigth" : "bg_lipstickligth" ) }>
                                <FormattedMessage id={"form_field_name_amount"} />
                                {(licencia.quota !== -1) &&
                                    <span>{": " + licencia.quotaUsed + " / " + licencia.quota}</span>
                                }
                                {(licencia.quota === -1) &&
                                    <span>{": " + licencia.quotaUsed}</span>
                                }
                            </div>
                        }
                        {data.map((u) => {
                            return u;
                        })}
                        {length > index + pagination && (
                            <Grid
                                container
                                justify="center"
                                className={'flex_grow_1 align_center margin_top_24'}
                            >
                                <Grid item xs={10} sm={6} className="padding_bottom_12">
                                    <BlueButton id="next" onClick={this.handleClick} />
                                </Grid>
                            </Grid>
                        )}
                    </div>
                </div>
            );
        }
    }
}

ListEmployees.propTypes = {
    users: PropTypes.array.isRequired,
    users_is_loading: PropTypes.bool.isRequired,
    users_has_errored: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        users: state.users,
        users_is_loading: state.users_is_loading,
        users_has_errored: state.users_has_errored,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, actionsHome), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(ListEmployees));



// WEBPACK FOOTER //
// ./src/components/complex/manage/users/List.js